import { useEffect, useState } from "react";
import { getPublicStatusSettings } from "../api/publicSettings";

const DEFAULT_STATUS = {
  bookingsEnabled: true,
  paymentsEnabled: true,
  seasonStartDate: null,
  seasonEndDate: null,
  updatedUtc: null,
  loading: true,
  error: "",
};

const usePublicAvailability = () => {
  const [status, setStatus] = useState(DEFAULT_STATUS);

  useEffect(() => {
    let cancelled = false;

    const loadStatus = async () => {
      try {
        const payload = await getPublicStatusSettings();
        if (cancelled) return;
        setStatus({
          bookingsEnabled: payload?.bookingsEnabled !== false,
          paymentsEnabled: payload?.paymentsEnabled !== false,
          seasonStartDate: payload?.seasonStartDate || null,
          seasonEndDate: payload?.seasonEndDate || null,
          updatedUtc: payload?.updatedUtc || null,
          loading: false,
          error: "",
        });
      } catch (error) {
        if (cancelled) return;
        setStatus((prev) => ({
          ...prev,
          loading: false,
          error: error?.message || "Failed to load booking status.",
        }));
      }
    };

    loadStatus();

    return () => {
      cancelled = true;
    };
  }, []);

  return status;
};

export default usePublicAvailability;
